<div class="modal" [ngClass]="{ 'is-active' : isModalActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Notice!</p>
            <button class="delete" aria-label="close" (click)="cancel()"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>See receptionist desk for details!</h1>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button is-success is-medium is-fullwidth" (click)="cancel()">OK</button>
        </footer>
    </div>
</div>